import { useCallback } from 'react'

export const useSilentRefetch = (refetch: () => Promise<unknown>) =>
  useCallback(() => {
    refetch().catch(() => undefined)
  }, [refetch])
